import axios from 'axios'

const baseURL = {
  default: process.env.VUE_APP_API_ENDPOINT,
  file_cdn: process.env.VUE_APP_IMG_API_ENDPOINT,
}

// api
const methods = {
  GET: (url, payloadOrParams, type) => axios({ method: 'GET', url, params: payloadOrParams, baseURL: baseURL[type] }),
  POST: (url, payloadOrParams, type) =>
    axios({
      method: 'POST',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  PATCH: (url, payloadOrParams, type) => axios({ method: 'PATCH', url, data: payloadOrParams, baseURL: baseURL[type] }),
  DELETE: (url, payloadOrParams, type) =>
    axios({ method: 'DELETE', url, params: payloadOrParams, baseURL: baseURL[type] }),
}
const api = (method, url, payloadOrParams, type = 'default') => {
  if (!Object.hasOwn(methods, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methods[method](url, payloadOrParams, type)
}

// api with token
const token = localStorage.getItem('authorization_token') || ''
const auth_header = {
  Authorization: 'Bearer ' + token,
}

const methods_auth = {
  GET: (url, payloadOrParams, type) =>
    axios({ method: 'GET', url, params: payloadOrParams, baseURL: baseURL[type], headers: auth_header }),
  POST: (url, payloadOrParams, type) =>
    axios({
      method: 'POST',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
      headers: auth_header,
    }),
  PATCH: (url, payloadOrParams, type) =>
    axios({ method: 'PATCH', url, params: payloadOrParams.params, data: payloadOrParams.payload, baseURL: baseURL[type], headers: auth_header }),
  DELETE: (url, payloadOrParams, type) =>
    axios({ method: 'DELETE', url, params: payloadOrParams, baseURL: baseURL[type], headers: auth_header }),
}
const apiAuth = (method, url, payloadOrParams, type = 'default') => {
  if (!Object.hasOwn(methods_auth, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methods_auth[method](url, payloadOrParams, type)
}

// api with files
const file_header = {
  Authorization: 'Bearer ' + token,
}
const methods_file = {
  POST: (url, payloadOrParams, type) =>
    axios({ method: 'POST', url, data: payloadOrParams, baseURL: baseURL[type], headers: file_header }),
  PATCH: (url, payloadOrParams, type) =>
    axios({ method: 'PATCH', url, data: payloadOrParams, baseURL: baseURL[type], headers: file_header }),
}
const apiFile = (method, url, payloadOrParams, type = 'default') => {
  if (!Object.hasOwn(methods_file, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methods_file[method](url, payloadOrParams, type)
}

export { api, apiFile, apiAuth }
